import { useMemo } from 'react';
import { PackEditorTabMode } from 'enums';
import { ACTIVITY_TYPES, PRIORITY_OPTION } from 'constants/general';
import { t } from 'services/i18n.service';
import { useAppSelectorShallow } from 'store/hooks';
import { moreOptionsAdvancedSelector } from 'store/reducer/setting/selectors';
import MoveActivity from './MoveActivity';
import CopyActivity from './CopyActivity';
import Tutorial from './Tutorial';
import ImpactMeasurement from './ImpactMeasurement';
import Category from './Category';
import LateCutoff from '../timing-tab/LateCutoff';

const AdvancedTab: React.FC = () => {
  const { activityType, packEditorTabMode, activity, isNewActivity, isUserAdmin } =
    useAppSelectorShallow(moreOptionsAdvancedSelector);

  const isActivityFromLibrary = activityType === ACTIVITY_TYPES.LIBRARY;
  const isBreakingRoutine = activityType === ACTIVITY_TYPES.BREAKING;

  const shouldShowTutorial = useMemo(
    () => !isNewActivity && !isActivityFromLibrary && !isBreakingRoutine,
    [isActivityFromLibrary, isBreakingRoutine, isNewActivity]
  );

  const shouldShowCopy = useMemo(
    () =>
      !isActivityFromLibrary &&
      !isBreakingRoutine &&
      Boolean(activity?.name?.trim()),
    [activity?.name, isActivityFromLibrary, isBreakingRoutine]
  );

  const shouldShowImpactMeasurement = useMemo(
    () =>
      isUserAdmin &&
      (packEditorTabMode === PackEditorTabMode.ROUTINE ||
        packEditorTabMode === PackEditorTabMode.STANDALONE),
    [isUserAdmin, packEditorTabMode]
  );
  const shouldShowLateCutoff = useMemo(
    () =>
      activityType === ACTIVITY_TYPES.EVENING &&
      activity?.priority === PRIORITY_OPTION.HIGH,
    [activity?.priority, activityType]
  );

  const shouldShowMove = !isActivityFromLibrary;

  return (
    <div className='w-full flex flex-col ~gap-6/8'>
      <p className='~text-xs/base flex flex-col'>
        {t('tabs_revamp.advanced_tab.advanced_settings')}
        <span className='~text-xs/sm text-gray-600 dark:text-gray-400'>
          {t('tabs_revamp.advanced_tab.advanced_settings_description')}
        </span>
      </p>

      {shouldShowLateCutoff && <LateCutoff />}
      {shouldShowMove && <MoveActivity />}
      {shouldShowCopy && <CopyActivity />}
      {shouldShowImpactMeasurement && <ImpactMeasurement />}
      {isActivityFromLibrary && <Category />}
      {shouldShowTutorial && <Tutorial />}
    </div>
  );
};

export default AdvancedTab;
